export const TINY = 'TINY'
export const SMALL = 'SMALL'
export const BASE = 'BASE'
export const MEDIUM = 'MEDIUM'
export const LARGE = 'LARGE'
export const XLARGE = 'XLARGE'
export const XXLARGE = 'XXLARGE'
export const HUGE = 'HUGE'
